module.exports = __webpack_public_path__ + "static/media/ascg.6d9a4b53.png";